import { parseISO } from 'date-fns'

/**
 * Default-window anchor (locked 2026-06-22, triage #5 / WP-B).
 *
 * The default timeframe ends at the page's latest DATA date, capped at today:
 *
 *     anchor = min(maxDataDate, today)
 *
 * - Past-ending facts (kpi_overall, model_success_kpi, model_tracking) anchor to their own
 *   last data date — the window opens on real data, never an empty tail.
 * - Forward-planned facts whose max_date is in the future (media_national,
 *   model_success_driver forecast to 2027) cap at today, so the page opens on recent data
 *   rather than the forecast horizon. The picker bounds are untouched — users can still
 *   select forward dates manually.
 *
 * Multi-fact pages pass the PRIMARY (active chart) fact's max_date by design. That keeps the
 * page's lead chart from opening on an empty tail. It is deliberately NOT max-across-facts:
 * on CP/Dynamics/MDD the modeled fact ends ~May while the driver fact runs to 2027, so a
 * max-across-facts anchor would tail the modeled chart by weeks.
 *
 * `today` is injected (callers pass the UTC calendar date) so this stays pure / testable.
 * Returns `undefined` when no data date is known yet — the caller gates rendering on that.
 */
export function resolveDefaultAnchor(maxDataDate: string | null, today: Date): Date | undefined {
  if (!maxDataDate) return undefined
  // max_date is a naive timestamp ("2026-05-23T22:00:00") → take the date part only.
  const dataDate = parseISO(maxDataDate.slice(0, 10))
  return dataDate > today ? today : dataDate
}
